import { useRouter } from 'next/router';
import { GQLInteractionType } from 'src/generated/graph-api';
import { useOptionalRouteParam } from '@/common/hooks/useOptionalRouteParam';

/**
 * Derive the id and type of the interaction and child interaction (if any)
 * from the router query and pathname.
 *
 * DIRECT USAGE OF THIS HOOK IS DISCOURAGED. Typesafe access of route parameters
 * with `useRouteParam` or `useSafeInteractionParams` is preferred wherever
 * possible.
 */
export function useInteractionParams() {
  const listingId = useOptionalRouteParam('listingId');
  const offerId = useOptionalRouteParam('offerId');
  const leaseId = useOptionalRouteParam('leaseId');
  const clientGroupId = useOptionalRouteParam('clientGroupId');
  const offerOnListingId = useOptionalRouteParam('offerOnListingId');
  const referralId = useOptionalRouteParam('referralId');
  const templateId = useOptionalRouteParam('templateId');

  const router = useRouter();
  const isListingRoute = router.pathname.includes('listings');
  const isOfferRoute =
    router.pathname.includes('offers') && !router.pathname.includes('listing');
  const isOfferOnListingRoute =
    router.pathname.includes('offers') && router.pathname.includes('listing');
  const isLeaseRoute = router.pathname.includes('leases');
  const isClientGroupRoute = router.pathname.includes('buyers');
  const isReferralRoute = router.pathname.includes('referrals');
  const isTemplateRoute = router.pathname.includes('templates');

  let interactionType: GQLInteractionType | undefined;
  let childInteractionId: string | undefined;
  let childInteractionType: GQLInteractionType | undefined;
  let interactionId: string | undefined;

  if (listingId || isListingRoute) {
    interactionType = GQLInteractionType.listing;
    interactionId = listingId;
  }
  if (offerId || isOfferRoute) {
    interactionType = GQLInteractionType.offer;
    interactionId = offerId;
  }
  if (leaseId || isLeaseRoute) {
    interactionType = GQLInteractionType.lease;
    interactionId = leaseId;
  }
  if (clientGroupId || isClientGroupRoute) {
    interactionType = GQLInteractionType.clientGroup;
    interactionId = clientGroupId;
  }
  if (referralId || isReferralRoute) {
    interactionType = GQLInteractionType.referral;
    interactionId = referralId;
  }
  if (templateId || isTemplateRoute) {
    interactionType = GQLInteractionType.userTemplate;
    interactionId = templateId;
  }
  if (isOfferOnListingRoute) {
    interactionId = listingId;
    interactionType = GQLInteractionType.listing;
    childInteractionType = GQLInteractionType.offer;
    childInteractionId = offerOnListingId;
  }

  return {
    interactionId,
    interactionType,
    childInteractionId,
    childInteractionType,
  };
}
